export enum REPORT_STATUS {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    RESOLVED = 'RESOLVED',
    REJECTED = 'REJECTED',
}

export enum ACCOUNT_STATUS {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    BANNED = 'BANNED',
}

export enum SANCTION_TYPE {
    WARNING = 'WARNING',
    CONTENT_REMOVAL = 'CONTENT_REMOVAL',
    SUSPENSION = 'SUSPENSION',
    BAN = 'BAN',
}